import { render, staticRenderFns } from "./UploadModal.vue?vue&type=template&id=9d879322&scoped=true"
import script from "./UploadModal.vue?vue&type=script&lang=ts"
export * from "./UploadModal.vue?vue&type=script&lang=ts"
import style0 from "./UploadModal.vue?vue&type=style&index=0&id=9d879322&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d879322",
  null
  
)

export default component.exports